import { render, staticRenderFns } from "./BasePageOneColumn.vue?vue&type=template&id=76ae2d62&functional=true&"
import script from "./BasePageOneColumn.vue?vue&type=script&lang=ts&"
export * from "./BasePageOneColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
